<template>
  <div class="stat-card-white" id="piechartcomp" ref="captureArea" :class="{ 'chart-empty-state': !loader && !hasChartData(data) }">
    <div class="stat-header-white">
      <span>{{ computedChartLabel }}</span>
      <div class="d-flex align-items-center" v-if="!loader">
        <select
          v-if="enableselectoption"
          class="graph-select py-0"
          v-model="selectedAttribute"
          id="attribute-select"
          @change="updateChart"
        >
          <option v-for="option in attributeOptions" :key="option" :value="option">
            {{ option }}
          </option>
        </select>

        <div v-if="!loader" class="expand-block px-2 mb-1 position-relative">
          <img
            class="cursor-pointer"
            @click="showtable()"
            src="../../assets//img/table_view.png"
            alt="More block"
          />
          <div class="more-expand">
            <span>{{ $t('navigations.data overview') }}</span>
          </div>
        </div>

        <div
          v-if="!loader"
          class="expand-block px-2 mb-1 cursor-pointer"
          @click.prevent="expandBlock = true"
        >
          <img src="../../assets//img/expand.png" alt="Expand block" />
        </div>

        <div class="text-center" v-on:clickout="showVisitPopup = false">
          <div
            class="position-relative cursor-pointer biggerfont ml-2"
            @click.prevent="showVisitPopup = !showVisitPopup"
          >
            <i class="fa fa-ellipsis-v"></i>
          </div>
          <div class="plan-side-popup" ref="excludeThis" v-if="showVisitPopup">
            <div @click.prevent="showVisitPopup = false, exporttoexcell()">Export to Excel</div>
            <div @click.prevent="exporttopdf()">Export to PDF</div>
            <div @click.prevent="exportDataPdf()">Export Data to PDF</div>
          </div>
        </div>
      </div>
    </div>

    <div class="stat-body-white chart-container d-flex flex-column" ref="chartContainerBlock">
      <div v-if="loader" class="loader"></div>

      <div v-if="!loader && selectedGroups.length != 0" class="selectdrill d-flex flex-row-reverse gap-2 w-100">
        <img
          class="cursor-pointer"
          src="../../assets/img/chart_cancel.png"
          @click.prevent="cancelselection()"
          alt="Cancel selection"
        />
        <img
          class="cursor-pointer"
          src="../../assets/img/chart_submit.png"
          @click.prevent="recreatechart()"
          alt="Apply selection"
        />
      </div>

      <div v-if="!loader">
        <label
          class="mr-2"
          v-if="(enrolledornot && fromPage == 'patientScreening') || fromPage == 'patientRetention'"
        >
          <input type="checkbox" v-model="aiPredictionTrue" @change="updateChart" /> {{ labelOne }}
        </label>
        <label
          v-if="(enrolledornot && fromPage == 'patientScreening') || fromPage == 'patientRetention'"
        >
          <input type="checkbox" v-model="aiPredictionFalse" @change="updateChart" /> {{ labelTwo }}
        </label>
      </div>

      <svg v-if="!loader" ref="chartContainer" viewBox="0 0 500 500"></svg>
      <div ref="tooltip" class="tooltip"></div>
    </div>
  </div>

  <enlargerpopup v-if="expandBlock == true" @closeModal="(expandBlock = false), updateChart()">
    <div class="stat-body-white d-flex flex-column w-100">
      <div v-if="!loader && selectedGroups.length != 0" class="selectdrill d-flex flex-row-reverse gap-2 w-100">
        <img
          class="cursor-pointer"
          src="../../assets/img/chart_cancel.png"
          @click.prevent="cancelselection()"
          alt="Cancel selection"
        />
        <img
          class="cursor-pointer"
          src="../../assets/img/chart_submit.png"
          @click.prevent="recreatechart()"
          alt="Apply selection"
        />
      </div>
      <svg ref="popupchartContainer"></svg>
    </div>
  </enlargerpopup>
</template>

<script>
import * as d3 from "d3";
import axios from "axios";
import store from "../../store/index";
import enlargerpopup from "../AiCharts/popupfiles/enlarge_popup.vue";
import * as XLSX from "xlsx";
import html2pdf from "html2pdf.js";

import chartEmptyStateMixin from "./chartEmptyStateMixin";

export default {
  name: "PieChart",
  mixins: [chartEmptyStateMixin],
  props: {
    data: { type: Array, required: true, default: () => [] },
    templateId: { type: String, default: "" },
    fromPage: { type: String, default: "" },
    enrolledornot: { type: Boolean, default: true },
    requiredtoclip: { type: Boolean, default: true },
    labelOne: { type: String, default: "Enrolled" },
    labelTwo: { type: String, default: "Non-enrolled" },
    chartlabel: { type: String, default: "Interactive Analysis" },
    loader: { type: Boolean, default: false },
    displayValue: { type: Boolean, default: true },
    percentage: { type: Boolean, default: true },
    xaxiskey: { type: String, default: "" },
    xaxisvariables: { type: Array, required: true, default: () => [] },
    tableData: { type: Array, required: true, default: () => [] },
    enableselectoption: { type: Boolean, default: true },
    colorcodes: { type: Array, default: () => [] },
    customColors: {
      type: Array,
      required: true,
      default: () => ["#28C0FF", "#FF98BD", "#8C82FF", "#FFB44F", "#57D9A5"],
    },
  },
  components: { enlargerpopup },
  computed: {
    computedChartLabel() {
      return this.chartlabel.replace("$$", this.selectedAttribute || "");
    },
  },
  data() {
    return {
      showVisitPopup: false,
      displaydrillpopup: false,
      expandBlock: false,
      showMore: false,
      graphdata: [],
      idtoken: "",
      baseApi: process.env.VUE_APP_Service_URL,
      mappings: {},
      svg: null,
      selectedAttribute: "",
      attributeOptions: [],
      aiPredictionTrue: true,
      aiPredictionFalse: true,
      singlecolor: "",
      resizeObserver: null,
      barselectedarray: [],
      sortdata: [],
      filterkeyword: "",
      filterarray: [],
      selectedGroups: [],
      chartContainer: null,
      mouseX: 0,
      mouseY: 0,
      colormapping: {},
      tooltip: null,
    };
  },
  watch: {
    data: {
      handler() {
        console.log("data in the etmfpiechart2 is :", this.data);
        this.graphdata = this.data;
        this.loadQuantitativeAttributes();
        this.cancelselection();
        this.updateChart();
      },
      deep: true,
    },
    selectedAttribute() {
      this.cancelselection();
      this.updateChart();
    },
    expandBlock(newValue) {
      if (newValue) {
        this.$nextTick(() => this.createChart());
      }
    },
  },
  async mounted() {
    window.addEventListener("mousemove", this.updateMousePosition);
    this.graphdata = this.data;
    this.idtoken = store.getters.getIdToken;
    if (this.fromPage == "patientScreening") {
      await this.createmapping();
    }
    this.tooltip = this.$refs.tooltip;
    this.createChart();

    // responsive
    this.resizeObserver = new ResizeObserver(() => this.updateChart());
    this.resizeObserver.observe(this.$refs.chartContainerBlock);
  },
  beforeUnmount() {
    window.removeEventListener("mousemove", this.updateMousePosition);
    if (this.resizeObserver) this.resizeObserver.disconnect();
  },
  methods: {
    // -------------------- exports --------------------
    async exporttoexcell() { this.$emit("exporttoexcell"); },
    exportDataPdf() { this.$emit("exportDataPdf"); },
    exporttopdf() {
      const excludeElement = this.$refs.excludeThis;
      if (excludeElement) excludeElement.style.display = "none";
      const pdfContainer = document.createElement("div");
      const captureArea = this.$refs.captureArea.cloneNode(true);
      pdfContainer.appendChild(captureArea);
      pdfContainer.style.width = "100%";
      pdfContainer.style.display = "block";
      const filename = this.computedChartLabel || "chart_data";
      const opt = {
        margin: 0,
        filename: `${filename}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "pt", format: "a4", orientation: "landscape" },
      };
      html2pdf().set(opt).from(pdfContainer).save();
    },

    // -------------------- interactions --------------------
    updateMousePosition(event) {
      const rect = this.$refs.chartContainerBlock.getBoundingClientRect();
      this.mouseX = event.clientX - rect.left;
      this.mouseY = event.clientY - rect.top;
    },
    backtooriginal() {
      this.sortdata = [];
      this.selectedGroups = [];
    },
    async cancelselection() {
      this.selectedGroups = [];
      this.sortdata = [];
      this.updateChart();
    },
    showtable() {
      this.showMore = false;
      this.$emit("opendrillpopup", this.data);
    },

    // -------------------- attribute setup --------------------
    async loadQuantitativeAttributes() {
      if (this.fromPage == "patientScreening" || this.fromPage == "patientRetention") {
        const sampleData =
          this.graphdata && this.graphdata.length > 0 && this.graphdata[0].features
            ? this.graphdata[0].features
            : {};
        const qualitativeAttributes = [];
        Object.keys(sampleData).forEach((key) => {
          const uniqueValues = new Set(this.graphdata.map((item) => item.features[key])).size;
          if (uniqueValues < 6) qualitativeAttributes.push(key);
        });
        this.attributeOptions = qualitativeAttributes;
        if (this.xaxiskey) this.selectedAttribute = this.xaxiskey;
        else if (!this.selectedAttribute) this.selectedAttribute = qualitativeAttributes[0] || "";
      }

      if (this.fromPage == "descriptiveStatistics" || this.fromPage == "deathSummary" || this.fromPage == "statusReport") {
        if (this.xaxisvariables.length === 0) {
          const qualitativeAttributes = [];
          if (this.graphdata[0]) {
            const keys = Object.keys(this.graphdata[0]).filter((key) =>
              !["_id", "Participant ID", "SubjectID", "USUBJID", "STUDYID", "SITEID",
                "DSSTDTC", "CMSCAT", "CMINDC", "RPDTC", "NATION", "CMCAT", "CMSCAT",
                "CMCOND", "RPNSDONE", "EDUCLVL", "DSREAS"].includes(key)
            );
            keys.forEach((key) => qualitativeAttributes.push(key));
            this.attributeOptions = qualitativeAttributes;
            this.selectedAttribute = this.xaxiskey || qualitativeAttributes[0] || "";
          }
        } else {
          this.attributeOptions = this.xaxisvariables;
          this.selectedAttribute = this.xaxiskey || this.xaxisvariables[0] || "";
        }
      }
    },

    async createmapping() {
      try {
        const response = await axios.get(
          `${this.baseApi}/forms/templatedesign/getpagesbyid?formId=${this.templateId}&version=1.0`,
          { headers: { Authorization: "Bearer " + this.idtoken, "Content-Type": "application/json" } }
        );
        if (response.data) {
          const pages = response.data.pages || [];
          pages.forEach((page) => {
            (page.field || []).forEach((field) => {
              if (field.options && field.options.length > 0) {
                this.mappings[field.fieldName] = field.options.reduce((map, option) => {
                  map[option.codevalue] = option.optionname;
                  return map;
                }, {});
              }
            });
          });
        }
      } catch (error) {
        console.log("Error creating mappings", error);
      }
    },

    // -------------------- core: validation + chart --------------------
    validateData(data) {
      if (this.fromPage == "patientScreening" || this.fromPage == "patientRetention") {
        return data.filter((d) => {
          const aiPrediction = d.features && d.features.AIPrediction;
          if ((aiPrediction && this.aiPredictionTrue) || (!aiPrediction && this.aiPredictionFalse)) {
            const v = (d.features && d.features[this.selectedAttribute]) || d[this.selectedAttribute];
            return v !== undefined && v !== null && String(v).trim() !== "";
          }
          return false;
        });
      }

      // descriptiveStatistics / deathSummary / statusReport
      return data.filter((d) => {
        // special case: grouping by documentVersion.versionStatus on entity array
        if (this.selectedAttribute === "versionStatus" && d && d.documentVersion) {
          const v = d.documentVersion.versionStatus;
          return v !== undefined && v !== null && String(v).trim() !== "";
        }
        const v = d && d[this.selectedAttribute];
        return v !== undefined && v !== null && String(v).trim() !== "";
      });
    },

    createChart() {
  const svgEl = this.expandBlock ? this.$refs.popupchartContainer : this.$refs.chartContainer;
  if (!svgEl) return;

  // wipe before drawing
  d3.select(svgEl).selectAll("*").remove();

  const raw = Array.isArray(this.graphdata) ? this.graphdata : [];
  const valid = Array.isArray(this.validateData(raw)) ? this.validateData(raw) : [];
  if (!valid.length) return;

  // ---- roll up data into categories ----
  const rolled = d3
    .rollups(
      valid,
      (v) => ({ count: v.length, subarray: v }),
      (d) => {
        let keyRaw;
        if (["patientScreening", "patientRetention"].includes(this.fromPage)) {
          keyRaw =
            d && d.features && d.features[this.selectedAttribute] != null
              ? d.features[this.selectedAttribute]
              : d[this.selectedAttribute];
        } else {
          if (this.selectedAttribute === "versionStatus" && d && d.documentVersion) {
            keyRaw = d.documentVersion.versionStatus;
          } else {
            const val = d[this.selectedAttribute];
            keyRaw = typeof val === "number" ? this.getRange(val) : val;
          }
        }
        const map = this.mappings[this.selectedAttribute];
        return map && map[keyRaw] != null ? map[keyRaw] : keyRaw;
      }
    )
    .map(([k, o]) => ({ key: k, value: o.count, subarray: o.subarray }));

  if (!rolled.length) return;
  const total = d3.sum(rolled, (d) => d.value);

  // ---- color mapping (stable across redraws) ----
  if (!this.colormapping[this.selectedAttribute]) this.colormapping[this.selectedAttribute] = {};
  for (let i = 0; i < rolled.length; i++) {
    const d = rolled[i];
    if (!this.colormapping[this.selectedAttribute][d.key]) {
      const used = Object.values(this.colormapping[this.selectedAttribute]);
      const pick = i < this.customColors.length ? this.customColors[i] : this.generateRandomColor(used);
      this.colormapping[this.selectedAttribute][d.key] = pick;
    }
  }

  const customColorMap = {};
  (this.colorcodes || []).forEach((c) => { customColorMap[c.type] = c.color; });

  // ---- legend labels & measure ----
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  ctx.font = "12px sans-serif";
  const labels = rolled.map((d) => {
    const pct = ((d.value / total) * 100).toFixed(2);
    return d.key + ": " + d.value + " (" + pct + "%)";
  });
  const widths = labels.map((t) => ctx.measureText(t).width);
  const maxW = Math.max(0, ...widths);

  // ---- layout ----
  const width = (this.$refs.chartContainerBlock && this.$refs.chartContainerBlock.clientWidth) || 400;
  const pieHeight = 280;
  const swatchW = 18;
  const gap = 6;
  const pad = 16;
  const lineH = 24;
  const itemW = swatchW + gap + maxW + pad;
  const perRow = Math.max(1, Math.floor(width / Math.max(1, itemW)));
  const rows = Math.ceil(rolled.length / perRow);
  const legendH = rows * lineH + 10;
  const svgHeight = pieHeight + legendH;
  const radius = Math.min(width, pieHeight) / 2 - 20;

  // ---- svg root ----
  this.svg = d3
    .select(svgEl)
    .attr("viewBox", "0 0 " + width + " " + svgHeight)
    .append("g")
    .attr("transform", "translate(" + width / 2 + "," + radius + ")");

  // ---- generators ----
  const pieGen = d3.pie().sort(null).value((d) => d.value);
  const arcGen = d3.arc().innerRadius(0).outerRadius(radius);

  // ---- slices ----
  const arcs = this.svg
    .selectAll(".arc")
    .data(pieGen(rolled))
    .enter()
    .append("g")
    .attr("class", "arc")
    .on("mouseover", (e, d) => {
      const pct = ((d.value / total) * 100).toFixed(2);
      d3.select(this.tooltip)
        .style("opacity", 1)
        .html("Category: " + d.data.key + "<br/>Value: " + d.data.value + "<br/>" + pct + "%")
        .style("left", this.mouseX + "px")
        .style("top", this.mouseY + "px");
    })
    .on("mouseout", () => {
      d3.select(this.tooltip).style("opacity", 0);
    })
    .on("mousemove", () => {
      d3.select(this.tooltip).style("left", this.mouseX + "px").style("top", this.mouseY + "px");
    })
    .on("click", (_e, d) => {
      this.arcclicked(d.data.subarray, d.data.key);
    });

  arcs
    .append("path")
    .attr("d", arcGen)
    .attr("fill", (d) => customColorMap[d.data.key] || this.colormapping[this.selectedAttribute][d.data.key])
    .attr("opacity", (d) => {
      if (Array.isArray(this.selectedGroups) && this.selectedGroups.length) {
        return this.selectedGroups.includes(d.data.key) ? 1 : 0.5;
      }
      return 1;
    });

  // ---- legend ----
  const legendY = radius + 10;
  const legend = this.svg.append("g").attr("class", "legend");

  const items = legend
    .selectAll(".legend-item")
    .data(rolled)
    .enter()
    .append("g")
    .attr("class", "legend-item")
    .attr("transform", (_d, i) => {
      const row = Math.floor(i / perRow);
      const col = i % perRow;
      const x = -width / 2 + col * itemW + gap;
      const y = legendY + row * lineH;
      return "translate(" + x + "," + y + ")";
    });

  items
    .append("rect")
    .attr("width", swatchW)
    .attr("height", swatchW)
    .attr("fill", (d) => customColorMap[d.key] || this.colormapping[this.selectedAttribute][d.key]);

  items
    .append("text")
    .attr("x", swatchW + gap)
    .attr("y", swatchW / 2)
    .attr("dy", "0.35em")
    .text((_, i) => labels[i])
    .style("font", "12px sans-serif");
},

    // -------------------- drilldown --------------------
    arcclicked(filteredData, filteredkeyword) {
      if (this.selectedGroups.includes(filteredkeyword)) {
        this.selectedGroups = this.selectedGroups.filter((k) => k !== filteredkeyword);
        var result = this.sortdata.filter(function (item) { return !filteredData.includes(item); });
        this.sortdata = result;
        this.filterarray = this.filterarray.filter(function (item) { return "(" + filteredkeyword + ")" !== item; });
        this.filterkeyword = this.selectedAttribute + "(" + this.selectedGroups + ")";
      } else {
        this.selectedGroups.push(filteredkeyword);
        this.filterarray.push("(" + filteredkeyword + ")");
        this.filterkeyword = this.selectedAttribute + "(" + this.selectedGroups + ")";
        this.sortdata = this.sortdata.concat(filteredData);
      }
      this.updateChart();
    },

    recreatechart() {
      this.$emit("drilldowncurrentchart", {
        sortedData: this.sortdata,
        filterkeyword: this.filterkeyword,
      });
    },

    updateChart() {
      this.chartContainer = this.expandBlock ? this.$refs.popupchartContainer : this.$refs.chartContainer;
      this.$emit("setxaxiskey", this.selectedAttribute);
      d3.select(this.chartContainer).selectAll("*").remove();
      this.svg = null;
      this.createChart();
    },

    // numeric bucket helper
    getRange(value) {
      var ranges = [0, 10, 20, 30, 40, 50];
      for (var i = 0; i < ranges.length - 1; i++) {
        if (value >= ranges[i] && value < ranges[i + 1]) return ranges[i] + "-" + ranges[i + 1];
      }
      return ranges[ranges.length - 1] + "+";
    },

    // color helper
    generateRandomColor(excludedColors) {
      var letters = "0123456789ABCDEF";
      var color;
      do {
        color = "#";
        for (var i = 0; i < 6; i++) color += letters[Math.floor(Math.random() * 16)];
      } while ((excludedColors || []).includes(color));
      return color;
    },
  },
};
</script>

<style scoped>
@import "../AiCharts/charts.css";

.pieminheight { min-height: 300px; }
.chart-container {
  overflow-x: auto; width: 100%;
  display: flex; justify-content: center; align-items: center;
}
.legend { margin-top: 10px; display: flex; justify-content: center; }
.legend-item { margin-right: 20px; display: flex; align-items: center; }
.legend-color { width: 20px; height: 20px; margin-right: 5px; }
.controls { margin-bottom: 10px; }
.controls label { margin-right: 5px; }
.controls select { margin-right: 15px; }
.pieheight { height: 400px; }

.loader {
  border: 6px solid #f3f3f3; border-top: 6px solid #3498db;
  border-radius: 50%; width: 40px; height: 40px;
  animation: spin 1s linear infinite; margin: 0 auto;
}
@keyframes spin { 0%{transform:rotate(0)} 100%{transform:rotate(360deg)} }
</style>
